module.exports = __webpack_public_path__ + "static/img/img_16.08c58ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events_gallery/img_16.jpg
// module id = Th4z
// module chunks = 0